import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none",
  viewBox: "0 0 14 14",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M2.333 11.667V2.333H10.5V1.167H1.167v11.666H10.5v-1.166H2.333Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M3.5 3.5H7v1.167H3.5V3.5ZM3.5 5.833h1.75V7H3.5V5.833Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.667 2.333 5.833 8.167V10.5h2.334L14 4.667l-2.333-2.334Zm.683 2.334L7.683 9.333H7V8.65l4.667-4.667.683.684Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }